
// Constantes relacionadas ao armazenamento de arquivos
export const BUCKET_NAME = 'profiles';
export const ATTACHMENTS_BUCKET_NAME = 'transaction-attachments';
export const DEFAULT_FILE_SIZE_LIMIT = 5 * 1024 * 1024; // 5MB
export const SYSTEM_FOLDER = 'system';
export const CUSTOM_FOLDER = 'custom';
